import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatIconModule } from "@angular/material/icon";
import { SharedModule } from "@app2/shared/shared.module";
import { TaskSchedulesSharedModule } from "@app2/task-schedules/task-schedules-shared.module";
import { AddEditTicketModalComponent } from "@app2/ticket/shared/add-edit-ticket-modal.component";
import {
    AddTicketDescriptionTemplateDropdownComponent
} from "@app2/ticket/shared/add-ticket-description-template-dropdown.component";
import { DueDateBadgeComponent } from "@app2/ticket/shared/due-date-badge.component";
import { MergeTicketsComponent } from "@app2/ticket/shared/merge-tickets.component";
import { ParentAndSubtasksComponent } from "@app2/ticket/shared/parent-and-subtasks.component";
import { TicketActionsDropdownComponent } from "@app2/ticket/shared/ticket-actions-dropdown.component";
import { TicketDueDateComponent } from "@app2/ticket/shared/ticket-due-date.component";
import { TicketEmbeddedListComponent } from "@app2/ticket/shared/ticket-embedded-list.component";
import { TicketLinksComponent } from "@app2/ticket/shared/ticket-links.component";
import { TicketListModalComponent } from "@app2/ticket/shared/ticket-list-modal.component";
import { TicketSelectionModalComponent } from "@app2/ticket/shared/ticket-selection-modal.component";
import { TicketStateBadgeComponent } from "@app2/ticket/shared/ticket-state-badge.component";
import { TicketStateEditComponent } from "@app2/ticket/shared/ticket-state-edit.component";
import { TicketViewPageWatchersComponent } from "@app2/ticket/shared/ticket-view-page-watchers.component";
import { TicketWatcherSelectComponent } from "@app2/ticket/shared/ticket-watcher-select.component";
import { TicketWatchersEditComponent } from "@app2/ticket/shared/ticket-watchers-edit.component";
import { TicketWatchersListComponent } from "@app2/ticket/shared/ticket-watchers-list.component";
import { WatcherSelectModalComponent } from "@app2/ticket/shared/watcher-select-modal.component";
import { TicketWatcherListItemComponent } from "@app2/ticket/shared/ticket-watcher-list-item.component";
import {
    TicketWatcherNotificationsSelectorComponent
} from "@app2/ticket/shared/ticket-watcher-notifications-selector.component";
import { TicketStateDropdownComponent } from "@app2/ticket/shared/ticket-state-dropdown.component";

// Use this module to export components that are used by other feature modules to avoid cyclic dependencies
@NgModule({
    imports: [
        CommonModule,
        SharedModule,
        FormsModule,
        ReactiveFormsModule,
        TaskSchedulesSharedModule,

        MatIconModule,
    ],
    declarations: [
        AddTicketDescriptionTemplateDropdownComponent,
        DueDateBadgeComponent,
        MergeTicketsComponent,
        ParentAndSubtasksComponent,
        TicketActionsDropdownComponent,
        TicketDueDateComponent,
        TicketEmbeddedListComponent,
        TicketLinksComponent,
        TicketStateBadgeComponent,
        TicketStateDropdownComponent,
        TicketStateEditComponent,
        TicketWatcherNotificationsSelectorComponent,
        TicketWatchersEditComponent,
        TicketWatchersListComponent,
        TicketWatcherListItemComponent,
        TicketWatcherSelectComponent,
        TicketViewPageWatchersComponent,

        // Modals
        AddEditTicketModalComponent,
        TicketListModalComponent,
        TicketSelectionModalComponent,
        WatcherSelectModalComponent,
    ],
    exports: [
        AddTicketDescriptionTemplateDropdownComponent,
        DueDateBadgeComponent,
        MergeTicketsComponent,
        ParentAndSubtasksComponent,
        TicketActionsDropdownComponent,
        TicketDueDateComponent,
        TicketEmbeddedListComponent,
        TicketLinksComponent,
        TicketStateDropdownComponent,
        TicketStateBadgeComponent,
        TicketStateEditComponent,
        TicketWatcherNotificationsSelectorComponent,
        TicketWatchersEditComponent,
        TicketWatchersListComponent,
        TicketWatcherListItemComponent,
        TicketWatcherSelectComponent,
        TicketViewPageWatchersComponent,
    ],
})
export class TicketSharedModule {
    constructor() {
    }
}
